<template>
  <v-dialog :value="isDialogVisible" @input="onDialogInput" persistent :max-width="1200">
    <v-card class="busqueda-modal pa-8">
      <v-row class="pa-0">
        <v-col cols="12" class="mt-mb-0 mt-sm-0 mt-1 text-right">
          <v-btn icon @click="cerrar">
            <v-icon size="25px">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <h1 class="modal-title text-center mb-8" :class="$vuetify.breakpoint.xsOnly ? 'text-h5' : ''">Detalle del candidato</h1>

      <div class="resultado-wrapper mb-16">
        <h3 class="nombre-empleado text-center mb-8">{{ resolvedPerson.nombre }}</h3>

        <v-row>
          <v-col cols="12" md="3" class="d-flex justify-center align-center mb-6 mb-md-0">
            <v-avatar size="160" class="avatar-empleado">
              <v-img :src="resolvedAvatarSrc" alt="Avatar de empleado" />
            </v-avatar>
          </v-col>

          <v-col cols="12" md="8">
            <div class="info-title mb-6">Datos personales</div>

            <v-row dense class="personal-data-grid">
              <v-col v-for="item in resolvedPersonalData" :key="item.label" cols="12" sm="6" md="3" class="mb-1">
                <div class="campo-label">{{ item.label }}</div>
                <div class="campo-value">{{ item.value }}</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <div class="action-buttons d-flex justify-center flex-wrap">
        <v-btn outlined rounded class="btn-cancel text-none" color="#1C1E4D" width="130" height="44" @click="cerrar">
          Cerrar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalDetalleCandidato',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    searchFields: {
      type: Object,
      default: () => ({}),
    },
    personData: {
      type: Object,
      default: null,
    },
    personalData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  computed: {
    isDialogVisible() {
      return this.visible;
    },
    resolvedPerson() {
      return this.personData || { nombre: '-', avatar: null };
    },
    resolvedAvatarSrc() {
      return this.resolvedPerson?.avatar || require('@/assets/img/default_user.png');
    },
    resolvedPersonalData() {
      return this.personalData;
    }
  },
  watch: {
    isDialogVisible(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.$emit('open');
      }

      if (!newVal && oldVal) {
        this.$emit('close');
      }
    },
  },
  methods: {
    onDialogInput(value) {
      if (value) {
        this.$emit('update:visible', true);
        return;
      }

      this.cerrar();
    },
    cerrar() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
:deep(.v-dialog) {
  border-radius: 40px;
  margin: 24px;
  overflow-y: auto;
  pointer-events: auto;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit;
  outline: none;
  color: #616161;
}

.busqueda-modal {
  border-radius: 40px;
}

.modal-title {
  font-size: 40px;
  font-weight: 700;
  color: #1C1E4D;
  line-height: 1.1;
}

.modal-subtitle {
  font-size: 18px;
  font-weight: 400;
  color: #1C1E4D;
}

.nombre-empleado {
  font-size: 28px;
  font-weight: 600;
  color: #1C1E4D;
  line-height: 1.2;
}

.avatar-empleado {
  background: linear-gradient(160deg, #dbdeeb 0%, #c9ccdb 100%);
  border: 2px solid #e4e5ea;
}

.info-title {
  width: 225px;
  text-align: center;
  background-color: #1C1E4D;
  color: #fff;
  border-radius: 12px 12px 0 0;
  padding: 10px 14px;
  font-size: 13px;
}

.campo-label {
  font-size: 11px;
  color: #555872;
  margin-bottom: 2px;
}

.campo-value {
  font-size: 12px;
  color: #1e2134;
  line-height: 1.2;
}

.personal-data-grid {
  margin-top: -4px;
}

.personal-data-grid>.col,
.personal-data-grid>[class*='col-'] {
  padding: 4px 6px !important;
}

.action-buttons {
  gap: 16px;
  margin-top: 12px;
}

@media (max-width: 1264px) {
  .modal-title {
    font-size: 40px;
  }

  .modal-subtitle {
    font-size: 17px;
  }

  .nombre-empleado {
    font-size: 26px;
  }

  .info-title {
    width: 100%;
    font-size: 15px;
  }

  .campo-label {
    font-size: 12px;
  }

  .campo-value {
    font-size: 17px;
  }
}
</style>
